import { useAtomValue } from 'jotai'
import { languageState } from '@repo/unicity'
import { appStore } from '@/core/store/jotai.store'

type LocalText = { native?: string; english?: string }

const resolveText = (text: LocalText | string | undefined | null, language: string): string => {
    if (!text) return ''
    if (typeof text === 'string') return text
    if (language === 'EN') return text.english || ''
    return text.native || text.english || ''
}

/**
 * Non-reactive text resolver — reads language at call time from appStore.
 * Safe inside .map(), useMemo, event handlers.
 * Reactivity is handled by App.tsx subscribing to languageState.
 */
export const localize = (text: LocalText | string | undefined | null): string => {
    return resolveText(text, appStore.get(languageState))
}

/**
 * Reactive hook — subscribes component to language changes.
 */
export const useCurrentLanguage = (): string => {
    return useAtomValue(languageState)
}
